import type { Process } from '../type/Process';

/**
 * Maps non-null process fields to formValues keys.
 * Null source values are skipped (key absent from output).
 * materialId and articleId are never included.
 */
export function processToFormValues(process: Process): Record<string, unknown> {
  const result: Record<string, unknown> = {};

  if (process.operator !== null) result.operator = process.operator;
  if (process.operation !== null) result.operation = process.operation;
  if (process.ae !== null) result.ae = process.ae;
  if (process.ap !== null) result.ap = process.ap;
  if (process.vc !== null) result.vc = process.vc;
  if (process.fz !== null) result.fz = process.fz;
  // volume, distance, duration_total, duration_piece are computed at submit (per-piece × pieces)
  // — they must NOT be pre-seeded into formValues from the process.
  if (process.machinedPieces !== null) result.pieces = process.machinedPieces;
  if (process.malround !== null) result.malrond = process.malround;
  if (process.lubType !== null) result.lubType = process.lubType;
  if (process.lubBrand !== null) result.lubBrand = process.lubBrand;
  if (process.holderType !== null) result.holderType = process.holderType;
  if (process.holderBrand !== null) result.holderBrand = process.holderBrand;
  if (process.clampingType !== null) result.clampingType = process.clampingType;
  if (process.clampingBrand !== null) result.clampingBrand = process.clampingBrand;

  // Only auto-fill machineId when exactly 1 machine — multiple machines require operator to choose
  if (process.machineIds.length === 1) {
    result.machineId = process.machineIds[0];
  }

  return result;
}
